import { connect } from 'react-redux';
import Change from '../../components/Change/Change';
import { PlansSelector } from '../reducers/PlansReducer';
import { MyAccountSelector } from '../reducers/MyAccountReducer';
import PlansAction from '../actions/PlansAction';

const mapStateToProps = state => ({
  customerInfo: MyAccountSelector.getCustomerInfo(state),
  availablePlans: PlansSelector.getAvailablePlans(state),
  selectedPlanId: PlansSelector.getSelectedPlanId(state),
  ufbAvailable: PlansSelector.getUfbAvailable(state),
  ufbReady: PlansSelector.getUfbReady(state)
});

const mapDispatchToProps = dispatch => ({
  setSelectedPlan: (id) => {
    dispatch(PlansAction.setSelectedPlan(id));
  }
});

const ChangeContainer = connect(mapStateToProps, mapDispatchToProps)(Change);

export default ChangeContainer;



/** WEBPACK FOOTER **
 ** ./src/redux/containers/ChangeContainer.js
 **/